import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Message } from "semantic-ui-react";
import { clearMessage } from "../../../store/Page";

function GlobalMessage() {
  const dispatch = useDispatch();
  const message = useSelector((state) => state.page.message);
  const messageRef = useRef(null);

  useEffect(() => {
    if (message) {
      // Scroll to message after DOM updates
      setTimeout(() => {
        if (messageRef.current) {
          messageRef.current.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
          });
        }
      }, 150);

      const timer = setTimeout(() => {
        dispatch(clearMessage());
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message, dispatch]);

  if (!message) return null;

  const errorList = message.errors
    ? Object.values(message.errors).flat()
    : [];

  // If errors exist, show them; else show text
  if (errorList.length > 0) {
    return (
      <div ref={messageRef}>
        <Message color="red" style={{ marginTop: 30 }}>
          <Message.List>
            {errorList.map((err, i) => (
              <Message.Item key={i}>{err}</Message.Item>
            ))}
          </Message.List>
        </Message>
      </div>
    );
  }

  if (message.text) {
    return (
      <div ref={messageRef}>
        <Message
          color={message.type === "success" ? "green" : "red"}
          style={{ marginTop: 30 }}
        >
          {message.text}
        </Message>
      </div>
    );
  }

  return null;
}

export default GlobalMessage;
